import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberInfoLogChangedModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_serial_number_info_log_changed",
                tableName: 'core_product_serial_number_info_log_changed'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            modified_date: { 
                name: 'modified_date', 
                type: "CustomDateTime", 
                label: 'Thời gian cập nhật',
                class: 'center',
                width: 13
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Người cập nhật',
                class: 'center',
                width: 20,
                computed: (data) => {
                    data.full_name = (data.users !== undefined && data.users !== null) ? data.users.full_name  :  '';
                }
            },
            organization: { 
                name: 'organization', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                type: "String",
                width: 15,
                computed: (data) => {
                    data.organization = (data.users !== undefined && data.users !== null && data.users.organization_account != null && data.users.organization_account.organization != null) ? data.users.organization_account.organization.name  :  '';
                }
            },
            content: { 
                name: 'content', 
                label: 'Nội dung cập nhật',
                class: 'center',
                width: 25,
                computed: (data) => {
                    if (data.new_value != null) {
                        var json = JSON.parse(data.new_value);
                        data.content  = (json.message != undefined && json.message != null) ? json.message : '';
                    }
                }
            },
            verify_status: { 
                name: 'verify_status', 
                type: "Selection",
                label: 'Trạng thái nghiệm thu',
                dataType: 'Label', 
                class: 'center',
                width: 13,
                options: [{ value: 1, label: 'Đã nghiệm thu'}, { value: 0, label: 'Chờ nghiệm thu'}, { value: 2, label: 'Không nghiệm thu'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                computed: (data) => {
                    if (data.new_value != null) {
                        var json = JSON.parse(data.new_value);
                        data.verify_status  = (json.verify_status != undefined && json.verify_status != null) ? json.verify_status : -1;
                    }
                }
            },
            warranty_status: { 
                name: 'warranty_status', 
                type: "Selection",
                label: 'Trạng thái bảo hành',
                dataType: 'Label', 
                class: 'center',
                width: 13,
                options: [{ value: 1, label: 'Đã kích hoạt'}, { value: 0, label: 'Chưa kích hoạt'}, { value: 2, label: 'Chờ kích hoạt'}, { value: 3, label: 'Đã kích hoạt'}, { value: 4, label: 'Hết bảo hành'}, {value: 6, label: 'Sản phẩm huỷ'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                computed: (data) => {
                    if (data.new_value != null) {
                        var json = JSON.parse(data.new_value);
                        data.warranty_status  = (json.warranty_status != undefined && json.warranty_status != null) ? (json.warranty_status == 5 ? 0 : json.warranty_status) : -1;
                    }
                }
            },
            modifier_id: {
                refs: ' request_activation_id serial_number_id users { full_name organization_account { organization { name provinces { id name } phone_number } } } new_value modified_date ',
                //refs: ' request_activation_id serial_number_id users { full_name organization_account { organization { name } } } new_value  modified_date ',
                display: false
            }
        },)
    }

}